export const MeetingState_Both_Expired = [
    '$scope', function($scope) {
        $scope.template = Evisors.config.cdnRootWhitelabel + 'asset/partials/consultations/meetingStates/both/expired.html';
    },
];
